module.exports = __webpack_public_path__ + "public/images/slider/malafeeva.343e67b1ee32bf1ceae7a28d0976f5b9.webp";